export interface IGridCell {
    name : string;
    visible : boolean;
    cssClasses : string;
    title : string;
    addValueAsCssClass? : boolean;

    dataType : string;
    currencyFormat : string;
    decimalSeparator : string;

    isLink? : boolean;
    url?: string;
    format? : string;
    icon? : string;
}


export interface IGridColumnCell {
    name : string;
    data : any;
    visible : boolean;
    cssClasses : string;
    title : string;
    addValueAsCssClass : boolean;

    dataType? : string;
    currencyFormat? : string;
    decimalSeparator? : string;

    format? : string;
}

export interface IGridDetailCell {
    name : string;
    data : any;
    visible : boolean;
    title : string;
    url : string;
    dataType? : string;
    currencyFormat? : string;
    decimalSeparator? : string;
}

export interface IGridDefinition {
    groupByColumnName : string;
    gridColumns : IGridCell[];
    gridDetailsColumns : any[];
    fieldContaningDetailsList? : string;
}

export class GridHelpers {
    static getHeaders(gridDefinition: IGridDefinition) : IGridCell[] {
        return gridDefinition.gridColumns.map((gridColumn : IGridCell) => {
            return {
                name: gridColumn.name,
                visible: gridColumn.visible,
                cssClasses: gridColumn.cssClasses,
                title: gridColumn.title,
                dataType: gridColumn.dataType || "",
                currencyFormat: gridColumn.currencyFormat || "",
                decimalSeparator: gridColumn.decimalSeparator || ""
            };
        });
    }

    static getColumns(gridData : any[], gridDefinition: IGridDefinition) : IGridColumnCell[] {
        return gridDefinition.gridColumns
            .map((gridColumn : IGridCell) => {
                return {
                    data: gridData[gridColumn.name],
                    name: gridColumn.name,
                    visible: gridColumn.visible,
                    cssClasses: gridColumn.cssClasses,
                    title: gridColumn.title,
                    addValueAsCssClass: gridColumn.addValueAsCssClass || false,
                    dataType: gridColumn.dataType || "",
                    currencyFormat: gridColumn.currencyFormat || "",
                    decimalSeparator: gridColumn.decimalSeparator || "",
                    isLink: gridColumn.isLink || false,
                    url: gridColumn.url || "",
                    format: gridColumn.format || "",
                    icon: gridColumn.icon || ""
                };
            });
    }

    static getDetailsForRow(gridData : any[], gridDefinition: IGridDefinition) : IGridDetailCell[] {
        return gridDefinition.gridDetailsColumns
            .filter((gridColumn: IGridCell) => gridData[gridColumn.name] !== undefined)
            .map((gridColumn : IGridCell) => {
                return {
                    data: gridData[gridColumn.name],
                    name: gridColumn.name,
                    visible: gridColumn.visible,
                    title: gridColumn.title,
                    url: gridColumn.url,
                    dataType: gridColumn.dataType || "",
                    currencyFormat: gridColumn.currencyFormat || "",
                    decimalSeparator: gridColumn.decimalSeparator || ""
                };
            });
    }

    static isRowPartOfGroup(gridData: any[], groupByColumnName: string, groupByColumnValue) : boolean {
        return (groupByColumnName === "") || 
            (gridData[groupByColumnName] === groupByColumnValue);
    }

    static getGroupsFromRows(dataRows: any[], groupByColumnName: string) : string[] {
        let groupHelper : string[] = [];
        dataRows.map((item) => {
            if (groupHelper.indexOf(item[groupByColumnName]) < 0) {
                groupHelper.push(item[groupByColumnName]);
                return true;
            } 
            return false;            
        });
        return groupHelper; 
    }
}